var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.buttons.length>0)?_c('div',{ref:"buttonsContainer",staticClass:"mw-toolbar"},_vm._l((_vm.buttons),function(button){return _c('el-button',{key:button.id,attrs:{"size":"small","type":"primary","id":button.id}},[_vm._v("\n      "+_vm._s(button.name)+"\n    ")])}),1):_vm._e(),_vm._v(" "),_c('div',{ref:"iframeContainer",staticClass:"mw-toolbar__body"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0aa00948","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/common/components/extend/ntko/ntko-editor.vue
// module id = 1025
// module chunks = 0 1